import { createAction, props } from '@ngrx/store';
import { UtilityValueRaw } from 'brain-data/model/utility-value-raw.model';

export const loadContractRawValues = createAction(
  '[ContractRawValues] load',
  props<{ contractNumber: string }>(),
);
export const loadContractRawValuesSuccess = createAction(
  '[ContractRawValues] load success',
  props<{ contractNumber: string; values: UtilityValueRaw[] }>(),
);
export const loadContractRawValuesError = createAction(
  '[ContractRawValues] load error',
  props<{ contractNumber: string; error: Error }>(),
);
